module.exports = __webpack_public_path__ + "img/main.09fedbf.png";